import { CabHubCompletedSurveyRow } from "../../../../secure/cab-hub/scripts/cab-hub-tracking.entities";


export class CabMonthlySurvey {
    Id: number;
    CabHubConnectionId: number;
    ReportingMonth: number;
    ReportingYear: number;
    MetThisMonth: boolean;
    NotMetExplanation: string;
    HoursWorked: number;
    AdditionalHoursCompensationRate: number;
    AnticipatedHoursNextMonthId: number;
    ConsultationTypeIds: string;
    OtherConsultationType: string;
    WorkDescription: string;
    SatisfactionRatingId: number;
    SatisfactionExplanation: string;
    SupportRequested: boolean;
    SupportRequestExplanation: string;
    TrainingNeededId: number;
    TrainingDescription: string;
    SubmittedByUserId: number;
    SubmittedDate: Date;

    static getDefault(connectionId: number, reportingMonth: number, reportingYear: number): CabMonthlySurvey {
        let survey: CabMonthlySurvey = {
            Id: 0,
            CabHubConnectionId: connectionId,
            ReportingMonth: reportingMonth,
            ReportingYear: reportingYear,
            MetThisMonth: undefined,
            NotMetExplanation: "",
            HoursWorked: 0,
            AdditionalHoursCompensationRate: null,
            AnticipatedHoursNextMonthId: 0,
            ConsultationTypeIds: "",
            OtherConsultationType: "",
            WorkDescription: "",
            SatisfactionRatingId: 0,
            SatisfactionExplanation: "",
            SupportRequested: false,
            SupportRequestExplanation: "",
            TrainingNeededId: 0,
            TrainingDescription: "",
            SubmittedByUserId: 0,
            SubmittedDate: new Date(1, 1, 1),
        } 

        return survey;
    }

    static convertSurveyRowVm(vm: CabHubCompletedSurveyRow): CabMonthlySurvey {
        let survey: CabMonthlySurvey = {
            Id: vm.SurveyId,
            CabHubConnectionId: vm.ConnectionId,
            ReportingMonth: vm.ReportingMonth,
            ReportingYear: vm.ReportingYear,
            MetThisMonth: vm.MetThisMonth,
            NotMetExplanation: vm.NotMetExplanation,
            HoursWorked: vm.HoursWorked,
            AdditionalHoursCompensationRate: vm.AdditionalHoursCompensationRate,
            AnticipatedHoursNextMonthId: vm.AnticipatedHoursNextMonthId,
            ConsultationTypeIds: vm.ConsultationTypeIds,
            OtherConsultationType: vm.OtherConsultationType,
            WorkDescription: vm.WorkDescription,
            SatisfactionRatingId: vm.SatisfactionRatingId,
            SatisfactionExplanation: vm.SatisfactionExplanation,
            SupportRequested: vm.SupportRequested,
            SupportRequestExplanation: vm.SupportRequestExplanation,
            TrainingNeededId: vm.TrainingNeededId,
            TrainingDescription: vm.TrainingDescription,
            SubmittedByUserId: vm.SubmittedByUserId,
            SubmittedDate: new Date(vm.SubmittedDate),
        } 
        return survey;
    }
}